import { render } from "./BranchProduct.vue?vue&type=template&id=39173168&scoped=true"
import script from "./BranchProduct.vue?vue&type=script&lang=js"
export * from "./BranchProduct.vue?vue&type=script&lang=js"

import "./BranchProduct.vue?vue&type=style&index=0&id=39173168&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39173168"]])

export default __exports__